import { httpMethod, useApi } from './useApi';
export const useCreateOrganization = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'organizations',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetOrganizations = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'users/organizations',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: {},
    });
    const responseData = data;
    return { call, data: responseData, error, ...rest };
};
export const useUpdateOrganization = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'organizations',
        httpMethod: httpMethod.PUT,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useGetOrganizationMembers = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'organizations/members',
        httpMethod: httpMethod.GET,
        body: {},
    });
    const callFunction = () => {
        call();
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useDeleteOrganizationMembers = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'organizations/members',
        httpMethod: httpMethod.DELETE,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useInviteMemeber = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'organizations/invitations',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
